<template>
  <main class="mall_main detail_page max-w-[82.75rem] mx-auto mb-40">
    <!-- 이전 페이지로 -->
    <!-- <div class="max-lg:px-4">
      <button
        @click="goBack"
        class="w-fit p-1 flex items-center gap-2"
        aria-label="이전 페이지로 이동"
      >
        <svg
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 9L22.5 9M1.5 9L8.22 1.5M1.5 9L8.22 16.5"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span class="leading-none text-sm">이전으로</span>
      </button>
    </div> -->

    <!-- 대표 영역: 썸네일 → 분류 → 제목 → 메타 → 구매 버튼 (가운데 정렬 단일 컬럼) -->
    <section class="detail_hero">
      <div class="detail_hero_thumb">
        <img
          v-if="contentDetail.thumbnailLink"
          :src="
            'https://eduwind-api.nodeblack.net/' + contentDetail.thumbnailLink
          "
          :alt="contentDetail.title"
          width="786"
          height="524"
        />
        <img
          v-else
          src="/assets/image/logo.svg"
          :alt="contentDetail.title"
          width="786"
          height="524"
          class="detail_hero_thumb_empty"
        />
      </div>

      <div class="detail_hero_info">
        <p v-if="heroCategory" class="detail_hero_category">
          {{ heroCategory }}
        </p>
        <h1 class="detail_hero_title">{{ contentDetail.title }}</h1>
        <div class="detail_hero_meta">
          <button type="button" @click="scrollToTarget('review')">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
              />
            </svg>
            사역리뷰 <b>{{ reviewTotal }}</b>
          </button>
          <span v-if="brandName" class="detail_hero_brand">{{
            brandName
          }}</span>
        </div>
      </div>

      <div class="detail_hero_buy">
        <button
          ref="heroCtaRef"
          type="button"
          class="detail_cta"
          :disabled="isSoldOut"
          @click="openPurchase"
        >
          <b v-if="isSoldOut">판매중지</b>
          <template v-else>
            <b
              ><em>{{ priceLabel }}</em> 장바구니 담기</b
            >
            <span v-if="ctaHint" class="detail_cta_hint">{{ ctaHint }}</span>
          </template>
        </button>

        <div class="detail_hero_sub">
          <p>{{ heroSubInfo }}</p>
          <button type="button" @click="scrollToTarget('info')">
            이용안내
          </button>
        </div>
      </div>
    </section>

    <!-- 이동 탭: 헤더 노출 여부(--sticky-top)에 맞춰 상단에 고정 -->
    <div ref="tabBarRef" class="detail_tabbar">
      <ul class="detail_tabbar_list">
        <li
          v-for="menu in visibleMenuList"
          :key="menu.id"
          :class="{ active: activeId === menu.id }"
        >
          <button
            type="button"
            :aria-current="activeId === menu.id ? 'true' : undefined"
            @click="scrollToTarget(menu.id)"
          >
            {{ menu.label }}
            <span v-if="menu.id === 'review'" class="detail_tabbar_count">{{
              reviewTotal
            }}</span>
          </button>
        </li>
      </ul>
    </div>

    <div class="detail_column">
      <!-- 콘텐츠 소개 -->
      <section id="intro" class="detail_section">
        <!-- <div class="detail_section_head">
          <h2>콘텐츠 소개</h2>
          <button
            type="button"
            class="detail_share"
            aria-label="링크 공유"
            @click="shareLink"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" />
            </svg>
          </button>
        </div> -->

        <!-- 핵심 정보 요약 -->
        <dl v-if="infoItems.length > 0" class="detail_summary">
          <div
            v-for="info in infoItems"
            :key="info.label"
            class="detail_summary_item"
          >
            <dt>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="info.icon" />
              </svg>
              {{ info.label }}
            </dt>
            <dd>{{ info.value }}</dd>
          </div>
        </dl>

        <!-- 활용 포인트 -->
        <div v-if="recommendItems.length > 0" class="detail_points">
          <p class="detail_points_title">이렇게 활용해 보세요</p>
          <ul>
            <li v-for="(rec, index) in recommendItems" :key="index">
              <span class="detail_points_icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="rec.icon" />
                </svg>
              </span>
              <div>
                <p class="detail_points_kind">{{ rec.kind }}</p>
                <p class="detail_points_text">
                  {{ rec.prefix }}<b>{{ rec.strong }}</b
                  >{{ rec.suffix }}
                </p>
              </div>
            </li>
          </ul>
        </div>

        <!-- 태그 -->
        <ul v-if="tagChips.length > 0" class="detail_tags">
          <li v-for="tag in tagChips" :key="tag">#{{ tag }}</li>
        </ul>

        <div
          class="detail_sample"
          v-if="
            contentDetail.sampleLink && contentDetail.contentType === 'VIDEO'
          "
        >
          <a
            :href="contentDetail.sampleLink"
            target="_blank"
            class="pri_btn p-4 flex justify-center items-center gap-1 rounded-lg"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.541672 12.6685C0.541672 9.58003 1.50834 6.88507 3.44167 4.58363C5.375 2.2822 7.79676 0.852657 10.7069 0.295015C10.9569 0.232537 11.1769 0.247923 11.3667 0.341174C11.5565 0.434425 11.6519 0.603676 11.6528 0.848927C11.6528 1.1007 11.5694 1.28861 11.4028 1.41263C11.2343 1.53759 11.0259 1.6341 10.7778 1.70217C8.23241 2.22904 6.1213 3.50892 4.44445 5.54179C2.76852 7.57467 1.93056 9.95024 1.93056 12.6685C1.93056 13.8202 2.08889 14.9219 2.40556 15.9738C2.72315 17.0247 3.17547 17.9945 3.7625 18.8832C3.9051 19.0819 3.975 19.2805 3.97223 19.4791C3.96945 19.6787 3.88612 19.8605 3.72223 20.0246C3.56482 20.185 3.40139 20.2419 3.23195 20.1953C3.0625 20.1487 2.91528 20.0372 2.79028 19.861C2.07269 18.8315 1.51852 17.7129 1.12778 16.5053C0.737042 15.2977 0.541672 14.0188 0.541672 12.6685ZM13.0417 25.2574C11.7009 25.2574 10.4236 25.0593 9.20973 24.6629C7.99584 24.2666 6.87825 23.7071 5.85695 22.9844C5.66991 22.8408 5.55325 22.6781 5.50695 22.4962C5.46065 22.3144 5.51389 22.1438 5.66667 21.9843C5.82593 21.8192 6.00417 21.7409 6.20139 21.7493C6.39862 21.7586 6.5963 21.8262 6.79445 21.9521C7.68149 22.5676 8.65278 23.039 9.70834 23.3663C10.7639 23.6945 11.875 23.8586 13.0417 23.8586C14.2083 23.8586 15.3194 23.6899 16.375 23.3523C17.4306 23.0157 18.4107 22.5401 19.3153 21.9256C19.5134 21.7997 19.7111 21.7307 19.9083 21.7185C20.1065 21.7073 20.2847 21.7843 20.4431 21.9493C20.5958 22.1079 20.6491 22.2799 20.6028 22.4655C20.5565 22.651 20.4398 22.8152 20.2528 22.9578C19.213 23.6805 18.0866 24.2447 16.8736 24.6504C15.6607 25.0551 14.3833 25.2574 13.0417 25.2574ZM25.5417 12.6685C25.5417 14.0188 25.3505 15.2935 24.9681 16.4927C24.5857 17.6919 24.0449 18.797 23.3458 19.8078C23.2032 20.0018 23.0431 20.1174 22.8653 20.1547C22.6875 20.192 22.5194 20.1314 22.3611 19.9729C22.1972 19.8069 22.1139 19.6246 22.1111 19.426C22.1083 19.2264 22.1778 19.0273 22.3194 18.8287C22.8898 17.9409 23.338 16.9804 23.6639 15.9472C23.9898 14.9112 24.1528 13.8183 24.1528 12.6685C24.1528 9.95024 23.3236 7.58352 21.6653 5.56837C20.006 3.55414 17.9042 2.27427 15.3597 1.72875C15.1107 1.66068 14.9023 1.56416 14.7347 1.43921C14.5681 1.31425 14.4847 1.12635 14.4847 0.875503C14.4847 0.630253 14.5755 0.461002 14.7569 0.367751C14.9384 0.2745 15.1537 0.259113 15.4028 0.321592C18.2963 0.895086 20.7093 2.32416 22.6417 4.60881C24.5741 6.89347 25.5407 9.58003 25.5417 12.6685ZM10.2639 16.6466V8.69042C10.2639 8.46382 10.3588 8.29876 10.5486 8.19525C10.7384 8.09081 10.931 8.10247 11.1264 8.23022L17.2667 12.1817C17.4398 12.303 17.5264 12.4652 17.5264 12.6685C17.5264 12.8718 17.4398 13.0341 17.2667 13.1553L11.1278 17.1068C10.9315 17.2346 10.7384 17.2462 10.5486 17.1418C10.3588 17.0383 10.2639 16.8732 10.2639 16.6466Z"
                fill="#0C3388"
              />
            </svg>
            <h3>샘플 영상 보기</h3>
          </a>
        </div>

        <div
          v-else-if="
            contentDetail.sampleLink && contentDetail.contentType === 'MUSIC'
          "
          class="detail_sample"
        >
          <div
            class="pri_btn p-4 flex justify-center items-center gap-1 rounded-lg max-md:flex-col"
          >
            <h3 class="mr-2">샘플 듣기</h3>
            <audio ref="audioPlayer" controls controlsList="nodownload">
              <source :src="contentDetail.sampleLink" type="audio/mpeg" />
              ※ 사용 중인 브라우저에서 음악 플레이어를 지원하지 않습니다.
            </audio>
          </div>
        </div>

        <div
          class="mall_detail_img mx-auto"
          :class="{ folded: isImageFolded, inactive: togglerActive }"
        >
          <p class="ql-container">
            <span class="ql-editor" v-html="contentDetail.description"></span>
          </p>

          <div v-if="togglerActive" class="mall_detail_toggle">
            <button type="button" @click="toggleImage">
              {{ isImageFolded ? "상품 설명 더보기" : "상품 설명 닫기" }}
            </button>
          </div>
        </div>
      </section>

      <!-- 이용안내 -->
      <section id="info" class="detail_section">
        <div class="detail_section_head">
          <h2>이용안내</h2>
        </div>

        <div class="detail_guide">
          <div>
            <h3>사용허가정보</h3>
            <ul>
              <li>콘텐츠는 제3자에게 배포, 판매, 양도, 대여할 수 없습니다.</li>
              <li>
                구매한 콘텐츠 원본은 SNS 포함 모든 온라인에 배포할 수 없습니다.
              </li>
              <li>
                영상 콘텐츠로의 편집 후 유투브등의 영상채널에 배포시 추가
                라이센스 획득 후 사용하셔야 합니다.
              </li>
              <li>
                웹 및 온라인 배포, 상업적 용도, 인쇄물 제작시에는 별도 확장
                라이센스 획득이 필요합니다.
              </li>
            </ul>
          </div>

          <div>
            <h3>환불안내</h3>
            <ul>
              <li>
                콘텐츠 다운로드시, 원하는 콘텐츠 인지 꼭 한번 더 확인을
                부탁드립니다.
              </li>
              <li>
                결제 및 다운로드 후 1개월 이내에는 횟수 제한 없이 재다운로드가
                가능합니다.
              </li>
              <li>
                결제 및 다운로드 후 1개월 이내에 콘텐츠 자체의 오류나 이상등이
                발견되는 경우 환불 조치가 가능하며, 환불대신 새파일을 받기
                요청하시면 새파일 다운로드 가능합니다.
              </li>
            </ul>
          </div>

          <div>
            <h3>저작권정보</h3>
            <p>본 콘텐츠의 저작권 및 책임은 총회교육개발원에 있습니다.</p>
          </div>
        </div>
      </section>

      <!-- 리뷰 섹션-->
      <section id="review" class="detail_section">
        <div class="detail_section_head">
          <h2>사역리뷰</h2>
          <span class="detail_section_count">{{ reviewTotal }}</span>
        </div>

        <ul
          v-if="reviewList.reviewList && reviewList.reviewList.length > 0"
          class="detail_review_list"
        >
          <li v-for="review in reviewList.reviewList" :key="review.reviewId">
            <div @click="getReviewDetail(review.reviewId)">
              <div class="flex items-center gap-x-2 mb-2">
                <p class="text-sm text-neutral-500">
                  {{ review.memberName }}
                </p>

                <span
                  class="ml-2 pl-3 leading-none border-l text-sm text-neutral-400"
                  >2025.02.24</span
                >
              </div>

              <div class="flex gap-1 items-center cursor-pointer">
                <p class="truncate max-w-[50%]">{{ review.reviewTitle }}</p>
                <button
                  type="button"
                  class="flex items-center gap-2 p-1 border border-neutral-400 rounded- text-xs ml-2"
                >
                  <svg
                    width="10"
                    height="7"
                    viewBox="0 0 10 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.833323 1.49999L4.99999 5.66666L9.16666 1.49999"
                      stroke="black"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div
                v-if="
                  reviewDetail.reviewId &&
                  reviewDetail.reviewId === review.reviewId
                "
                class="mt-2 p-2 font-light"
              >
                <div
                  v-html="reviewDetail.reviewDescription"
                  class="reviewDetailContainer"
                ></div>
              </div>
            </div>
          </li>
        </ul>
        <div v-else class="detail_review_empty">
          <p>아직 등록된 리뷰가 없습니다.</p>
          <button class="pri_btn_bg px-4 py-3 rounded">
            첫번째 리뷰 작성하기
          </button>
        </div>
      </section>

      <!-- 연관 콘텐츠 -->
      <section
        id="relative"
        class="detail_section"
        v-if="
          contentDetail.relationItemList &&
          contentDetail.relationItemList.length > 0
        "
      >
        <div class="detail_section_head">
          <h2>연관 콘텐츠</h2>
        </div>

        <menu class="product_grid_container detail_related">
          <li
            v-for="related in contentDetail.relationItemList"
            :key="related.itemId"
            class="product_grid_wr"
          >
            <!-- 상품 thumb -->
            <div
              class="product_thumb mb-2 cursor-pointer"
              @click="refreshPage(related.itemId)"
            >
              <img
                v-if="related.thumbnailLink"
                :src="
                  'https://eduwind-api.nodeblack.net/' + related.thumbnailLink
                "
              />
              <img
                v-else
                src="@/assets/img/null_img.jpg"
                :alt="contentDetail.title"
              />
            </div>

            <!-- 상품설명 -->
            <div class="product_desc space-y-2">
              <p
                class="product_tt cursor-pointer"
                @click="refreshPage(related.itemId)"
              >
                {{ related.title }}
              </p>
              <div
                class="flex gap-1 product_price"
                v-if="related.sellingPrice > 0"
              >
                <strong v-if="related.discountRate > 0"
                  >{{ related.discountRate }}%</strong
                >
                {{ related.sellingPrice.toLocaleString() }} 원
                <p v-if="related.sellingPrice < related.regularPrice">
                  {{ related.regularPrice.toLocaleString() }} 원
                </p>
              </div>
              <div v-else>무료</div>
            </div>
          </li>
        </menu>
      </section>

      <router-link
        to="/mall"
        type="button"
        class="w-fit flex items-center mt-8 gap-4 px-6 py-3 mx-auto rounded pri_btn_bg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
        >
          <path d="M9.5 1.5L1.5 9.5L9.5 17.5" stroke="white" stroke-width="2" />
          <path d="M19.5 9.5H1.5" stroke="white" stroke-width="2" />
        </svg>
        목록으로
      </router-link>
    </div>

    <Teleport to="body">
      <!-- 하단 플로팅 구매바: 대표 영역의 구매 버튼이 화면 밖으로 나가면 노출 -->
      <Transition name="detail-float">
        <div
          v-if="isFloatingVisible && !isPurchaseSheetOpen"
          class="detail_float"
        >
          <div class="detail_float_info">
            <p class="detail_float_title">{{ contentDetail.title }}</p>
            <p class="detail_float_price">
              <strong v-if="hasDiscount"
                >{{ contentDetail.discountRate }}%</strong
              >{{ priceLabel }}
            </p>
          </div>
          <button
            type="button"
            class="detail_cta detail_cta--float"
            :disabled="isSoldOut"
            @click="openPurchase"
          >
            <b>{{ isSoldOut ? "판매중지" : "장바구니 담기" }}</b>
          </button>
        </div>
      </Transition>

      <!-- 옵션 선택 시트: 모바일은 하단 시트, 데스크톱은 가운데 모달 -->
      <Transition name="detail-sheet">
        <div
          v-if="isPurchaseSheetOpen"
          class="detail_sheet_backdrop"
          @click.self="closePurchaseSheet"
        >
          <div
            class="detail_sheet"
            role="dialog"
            aria-modal="true"
            aria-labelledby="detail-sheet-title"
          >
            <div class="detail_sheet_head">
              <h2 id="detail-sheet-title">
                {{
                  contentDetail.itemType === "PRODUCT"
                    ? "옵션 선택"
                    : "사용용도 선택"
                }}
              </h2>
              <button
                ref="sheetCloseRef"
                type="button"
                aria-label="닫기"
                @click="closePurchaseSheet"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  aria-hidden="true"
                >
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div class="detail_sheet_body">
              <p class="detail_sheet_item">{{ contentDetail.title }}</p>

              <!-- 이미지 사용용도 -->
              <fieldset
                v-if="contentDetail.contentType === 'IMAGE'"
                class="detail_license"
              >
                <legend class="sr-only">사용용도</legend>
                <label
                  v-for="imgOption in contentDetail.contentImage
                    ?.imageLicenseList || []"
                  :key="imgOption.contentImageLicenseId"
                  class="detail_license_item"
                  :class="{
                    checked:
                      selectedLicense === imgOption.contentImageLicenseId,
                  }"
                >
                  <input
                    v-model="selectedLicense"
                    type="radio"
                    name="detail-license"
                    :value="imgOption.contentImageLicenseId"
                    class="sr-only"
                  />
                  <span class="detail_license_name">{{
                    imgOption.licenseName
                  }}</span>
                  <span
                    v-if="imgOption.licenseDescription"
                    class="detail_license_desc"
                    >{{ imgOption.licenseDescription }}</span
                  >
                  <b class="detail_license_price"
                    >{{ imgOption.licensePrice.toLocaleString() }}원</b
                  >
                </label>
              </fieldset>

              <!-- 상품 옵션 -->
              <template v-if="contentDetail.itemType === 'PRODUCT'">
                <div class="detail_delivery">
                  <span>배송비</span>
                  <div>
                    <div>
                      <b v-if="contentDetail.isADFActive === true">
                        {{
                          numberWithCommas(contentDetail.additionalDeliveryFee)
                        }}
                      </b>
                      <b v-else>
                        {{ numberWithCommas(warehouseInfo.deliveryFee) }}
                      </b>
                      원(주문시 결제) - {{ warehouseInfo.deliveryCompany }}
                    </div>
                    <div>
                      {{ warehouseInfo.deliveryFreeOption.toLocaleString() }}원
                      이상 구매 시 무료
                    </div>
                  </div>
                </div>

                <div v-if="noneOptionItem === false" class="space-y-3">
                  <div
                    v-for="(option, index) in requiredOptionSetting"
                    :key="'required' + index"
                  >
                    <p class="detail_option_label">필수 옵션</p>
                    <select
                      v-model="selectedOption[index]"
                      class="selectClass"
                      @change="combinationSelectOption(option, index, 'R')"
                    >
                      <option value="">{{ option.optionName }}</option>
                      <template v-if="option.optionNodeList.length > 0">
                        <option
                          v-for="(node, nodeIndex) in option.optionNodeList"
                          :key="nodeIndex"
                          :value="node"
                        >
                          {{ node.elementName
                          }}{{
                            node.price > 0
                              ? `(+${numberWithCommas(node.price)})`
                              : ""
                          }}
                        </option>
                      </template>
                      <option
                        v-if="option.optionNodeList.length <= 0 && index > 0"
                        value=""
                      >
                        {{ requiredOptionSetting[index - 1].optionName }}
                        옵션을 먼저 선택해 주세요.
                      </option>
                    </select>
                  </div>

                  <div
                    v-for="(option, index) in normalOptionSetting"
                    :key="'normal' + index"
                  >
                    <p class="detail_option_label">선택 옵션</p>
                    <select
                      v-model="normalOption[index]"
                      class="selectClass"
                      @change="normalSelectOption(option, index, 'N')"
                    >
                      <option value="">{{ option.optionName }}</option>
                      <template v-if="option.optionNodeList.length > 0">
                        <option
                          v-for="(node, nodeIndex) in option.optionNodeList"
                          :key="nodeIndex"
                          :value="node"
                        >
                          {{ node.elementName }}
                          {{ node.price > 0 ? " - " + node.price + "원" : "" }}
                        </option>
                      </template>
                    </select>
                  </div>

                  <div
                    v-for="(option, index) in writeSetting"
                    :key="'write' + index"
                  >
                    <p class="detail_option_label">{{ option.optionName }}</p>
                    <div class="flex justify-between gap-1">
                      <input
                        type="text"
                        class="selectClass flex-1"
                        v-model="option.inputData"
                        @keyup.enter="makeWriteOption(option)"
                      />
                      <button
                        type="button"
                        class="px-4 border border-neutral-300 rounded-lg"
                        @click="makeWriteOption(option)"
                      >
                        추가
                      </button>
                    </div>
                  </div>

                  <ul
                    v-if="selectedOptionList.length > 0"
                    class="detail_selected_list"
                  >
                    <li
                      v-for="(item, index) in selectedOptionList"
                      :key="index"
                    >
                      <div class="flex justify-between gap-2 mb-2">
                        <span>{{ item.title }}</span>
                        <button
                          type="button"
                          class="text-neutral-400 hover:text-neutral-800"
                          aria-label="선택 옵션 삭제"
                          @click="deleteCart(item)"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            aria-hidden="true"
                          >
                            <path d="M18 6 6 18M6 6l12 12" />
                          </svg>
                        </button>
                      </div>

                      <div class="flex justify-between items-center">
                        <div class="countBox" data-hs-input-number>
                          <div class="flex items-center gap-x-1.5">
                            <button
                              type="button"
                              class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                              data-hs-input-number-decrement
                              aria-label="수량 감소"
                              @click="optionDecreaseQuantity(item, index)"
                            >
                              <svg
                                class="flex-shrink-0 size-3.5"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M5 12h14" />
                              </svg>
                            </button>

                            <input
                              class="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0"
                              type="text"
                              v-model="item.count"
                              data-hs-input-number-input
                            />

                            <button
                              type="button"
                              class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                              data-hs-input-number-increment
                              aria-label="수량 증가"
                              @click="optionIncreaseQuantity(item, index)"
                            >
                              <svg
                                class="flex-shrink-0 size-3.5"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                              </svg>
                            </button>
                          </div>
                        </div>

                        <b>{{ numberWithCommas(item.totalPrice) }}원</b>
                      </div>
                    </li>
                  </ul>
                </div>

                <div v-else class="flex justify-between items-center">
                  <span>수량</span>
                  <div class="countBox" data-hs-input-number>
                    <div class="flex items-center gap-x-1.5">
                      <button
                        type="button"
                        class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                        data-hs-input-number-decrement
                        aria-label="수량 감소"
                        @click="optionDecreaseQuantityNone()"
                      >
                        <svg
                          class="flex-shrink-0 size-3.5"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14" />
                        </svg>
                      </button>

                      <input
                        class="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0"
                        type="text"
                        v-model="noneOptionItemInfo.productStock"
                        data-hs-input-number-input
                      />

                      <button
                        type="button"
                        class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                        data-hs-input-number-increment
                        aria-label="수량 증가"
                        @click="optionIncreaseQuantityNone()"
                      >
                        <svg
                          class="flex-shrink-0 size-3.5"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14" />
                          <path d="M12 5v14" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="detail_sheet_foot">
              <div class="detail_sheet_total">
                <span>총 상품 금액</span>
                <b>{{ numberWithCommas(sheetTotalPrice) }}원</b>
              </div>
              <button
                type="button"
                class="detail_cta detail_cta--sheet"
                @click="addCart"
              >
                <b>장바구니 담기</b>
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- 리뷰 사진 모달 -->
    <ReviewPhotoModal
      :isVisible="isPhotoModalVisible"
      :photos="reviewPhotos"
      :initialIndex="selectedPhotoIndex"
      @close="closePhotoModal"
      @photoChange="handlePhotoChange"
    />
  </main>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import router from "@/router";
import axios from "axios";
import { openLoginDialog } from "@/composables/useLoginDialog";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { numberWithCommas } from "@/assets/js/util.js";

import { editCart } from "@/assets/js/cart.js";
import ReviewPhotoModal from "@/components/ReviewPhotoModal.vue";

const quantity = ref(1);
const isImageFolded = ref(false);
const togglerActive = ref(false);

const contentDetail = ref({});
const selectedLicense = ref(null);

// 팝오버 관련 변수들
const activePopover = ref(null);
const popoverTimer = ref(null);

// 팝오버 데이터 정의
const popoverData = ref([
  {
    id: "satisfaction",
    icon: "👍",
    label: "만족(98%, 불만족 1%)",
    content: "많은 고객님들께서 컨텐츠 내용에 만족하셨어요.",
  },
  {
    id: "elementary",
    icon: "🏫",
    label: "유년부(75%, 유치부 20%)",
    content: "유년부 및 유치부 공과로 많이 사용되었어요.",
  },
  {
    id: "hanabible",
    icon: "📖",
    label: "하나 바이블",
    content: "하나 바이블 공과로 많이 사용되었어요.",
  },
]);

const route = useRoute();
const itemId = route.params.itemId;

// 탭 클릭으로 이동
const menuList = [
  { label: "콘텐츠 소개", id: "intro" },
  { label: "이용안내", id: "info" },
  { label: "사역리뷰", id: "review" },
  { label: "연관콘텐츠", id: "relative" },
];

// 연관 콘텐츠가 없으면 해당 탭은 숨긴다
const visibleMenuList = computed(() =>
  menuList.filter(
    (menu) =>
      menu.id !== "relative" ||
      contentDetail.value.relationItemList?.length > 0,
  ),
);

const activeId = ref("intro");

const heroCtaRef = ref(null); // 대표 영역 구매 버튼
const tabBarRef = ref(null); // 이동 탭
const sheetCloseRef = ref(null); // 옵션 시트 닫기 버튼
const isFloatingVisible = ref(false); // 하단 플로팅 구매바 노출 여부
const isPurchaseSheetOpen = ref(false); // 옵션 선택 시트 노출 여부

// 요약 정보 아이콘 (24x24 stroke path)
const INFO_ICON = {
  maker:
    "M3 21h18M5 21V7l7-4 7 4v14M9 10h1M14 10h1M9 14h1M14 14h1M10 21v-3h4v3",
  book: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z",
  file: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6",
  tag: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2",
  sun: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41",
  folder:
    "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z",
};

// 활용 포인트 아이콘 (24x24 stroke path)
const POINT_ICON = {
  target:
    "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  place:
    "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  education:
    "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z",
};

// 이전 페이지로 이동하는 함수
const goBack = () => {
  // 브라우저 히스토리가 있으면 뒤로가기, 없으면 콘텐츠 몰로 이동
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push("/mall");
  }
};

const reviewList = ref({});
const reviewDetail = ref({});

// 리뷰 사진 모달 관련 상태
const isPhotoModalVisible = ref(false);
const reviewPhotos = ref([]);
const selectedPhotoIndex = ref(0);
// 옵션 업는 상풍 관련 변수들
const noneOptionItem = ref(false); // 옵션 있는 상품인지 아닌지
const noneOptionItemInfo = ref({
  itemId: null,
  isSelected: true,
  quantity: null,
  licenseId: null,
  productStock: 1, // 옵션 없는 상품 보낼때 사용
  command: null,
}); // 옵션 없는 상품 정보
const noneOptionItemPrice = ref(0); // 옵션 없는 상품 가격
const noneOptionItemTotalPrice = ref(0); // 옵션 없는 상품 총 가격

// 조합형 옵션 예시
const combinationOptionSetting = ref([
  {
    idx: 1,
    type: "default",
    title: "사이즈",
    values: ["S", "M", "L", "XL"],
    isRequire: true,
    price: 11000,
  },
  {
    idx: 2,
    type: "default",
    title: "색상",
    values: [],
    isRequire: true,
    price: 12000,
  },
  {
    idx: 3,
    type: "default",
    title: "재질",
    values: [],
    isRequire: true,
    price: 13000,
  },
]);
const selectedOption = ref([]);
const selectedOptionList = ref([]);
const selectedOptionTitle = ref(null);

const hanaBibleInfo = computed(() => {
  let semester = contentDetail.value.semester;
  if (semester && semester.includes("-")) {
    const [course, term] = semester.split("-");
    semester = `${course}과정 ${term}학기`;
  }
  let lesson = contentDetail.value.lesson
    ? `${contentDetail.value.lesson}과`
    : null;
  const parts = [semester, lesson, contentDetail.value.division].filter(
    (part) => part && part.trim() !== "",
  );

  if (parts.length === 0) return null;

  return parts.join(" - ");
});

const itemKindList = ref([
  { value: "", label: "전체" },
  { value: "LESSON", label: "공과" },
  { value: "SCHOOL", label: "성경학교" },
  { value: "REGULAR", label: "정기" },
  { value: "OTHERS", label: "기타" },
]);
const contentTypeList = ref([
  { value: "", label: "전체" },
  { value: "IMAGE", label: "이미지" },
  { value: "VIDEO", label: "영상" },
  { value: "FILE", label: "파일" },
  { value: "MUSIC", label: "음원(MR, 악보)" },
]);

const normalOption = ref([]);
// 일반 선택 옵션 예시
const normalOptionSetting = ref([]);

const warehouseInfo = ref({});

const brandName = computed(() => contentDetail.value.brand?.name?.trim() || "");

const contentTypeLabel = computed(() => {
  const contentType = contentDetail.value.contentType;
  if (!contentType) return "";
  return contentTypeList.value.find((item) => item.value === contentType)
    ?.label;
});

const downloadPeriodLabel = computed(() =>
  contentDetail.value.downloadPeriod > 0
    ? contentDetail.value.downloadPeriod + "일"
    : "제한 없음",
);

const reviewTotal = computed(
  () =>
    reviewList.value.pageInfo?.total ??
    reviewList.value.reviewList?.length ??
    0,
);

const isSoldOut = computed(() => contentDetail.value.itemStatus === "STOP");

const hasDiscount = computed(
  () =>
    contentDetail.value.isFree === false &&
    contentDetail.value.regularPrice > contentDetail.value.sellingPrice,
);

const priceLabel = computed(() => {
  const item = contentDetail.value;
  if (item.isFree === true) return "무료";
  if (item.sellingPrice == null) return "";
  return `${numberWithCommas(item.sellingPrice)}원`;
});

// 사용용도(이미지) 또는 상품 옵션을 골라야 하는 경우에만 시트를 연다
const needsPurchaseSheet = computed(
  () =>
    contentDetail.value.itemType === "PRODUCT" ||
    contentDetail.value.contentType === "IMAGE",
);

const ctaHint = computed(() => {
  const item = contentDetail.value;
  if (hasDiscount.value) {
    return `정가 ${numberWithCommas(item.regularPrice)}원 · ${
      item.discountRate
    }% 할인`;
  }
  if (item.itemType === "PRODUCT" && noneOptionItem.value === false) {
    return "옵션을 선택해 주세요";
  }
  if (item.contentType === "IMAGE") return "사용용도를 선택해 주세요";
  return "";
});

// 대표 영역 분류 표기 (예: 하나바이블 · 청소년부)
const heroCategory = computed(() => {
  const path = contentDetail.value.categoryList?.[0]?.categoryFullPath;
  if (path) {
    return path
      .split(/\s*[>/]\s*/)
      .filter(Boolean)
      .join(" · ");
  }
  return contentTypeLabel.value || "";
});

const heroSubInfo = computed(() => {
  const item = contentDetail.value;
  if (item.itemType === "PRODUCT") {
    const warehouse = warehouseInfo.value || {};
    if (!warehouse.deliveryCompany) return "";
    const fee =
      item.isADFActive === true
        ? item.additionalDeliveryFee
        : warehouse.deliveryFee;
    return `배송비 ${numberWithCommas(fee ?? 0)}원 · ${numberWithCommas(
      warehouse.deliveryFreeOption ?? 0,
    )}원 이상 무료`;
  }
  if (item.itemType === "CONTENT") {
    return `다운로드 기간 : ${downloadPeriodLabel.value}`;
  }
  return "";
});

const infoItems = computed(() => {
  const item = contentDetail.value;
  const items = [];
  const push = (label, value, icon) => {
    if (value) items.push({ label, value, icon });
  };

  push("제작사", brandName.value, INFO_ICON.maker);
  push("하나 바이블", hanaBibleInfo.value, INFO_ICON.book);
  if (item.itemType === "CONTENT") {
    push("콘텐츠 유형", contentTypeLabel.value, INFO_ICON.file);
    push(
      "콘텐츠 분류",
      item.itemKind &&
        itemKindList.value.find((kind) => kind.value === item.itemKind)?.label,
      INFO_ICON.tag,
    );
    push("다운로드 기간", downloadPeriodLabel.value, INFO_ICON.clock);
  }
  push(
    "관련 성경",
    item.bibleList
      ?.map((bible) => `${bible.bookName} ${bible.chapter}장`)
      .join(", "),
    INFO_ICON.book,
  );
  push("관련 절기", item.solarTerm, INFO_ICON.sun);
  push(
    "카테고리",
    item.categoryList?.map((category) => category.categoryName).join(", "),
    INFO_ICON.folder,
  );
  return items;
});

const recommendItems = computed(() => {
  const item = contentDetail.value;
  const targets = getGroupedTargets(item.targetGroupList).map((batch) => ({
    kind: "추천 대상",
    icon: POINT_ICON.target,
    prefix: "",
    strong: batch.names,
    suffix: batch.suffix,
  }));
  const contexts = (item.itemUsageContextList || []).map((ctx) => ({
    kind: "사용 장소",
    icon: POINT_ICON.place,
    prefix: "",
    strong: ctx.name,
    suffix: "에서 사용해요",
  }));
  const educations = (item.itemEducationInfoList || []).map((edu) => ({
    kind: "연계 교육",
    icon: POINT_ICON.education,
    prefix: `${edu.curriculumSeries} ${edu.curriculumSeason} - `,
    strong: edu.itemTitle,
    suffix: "",
  }));
  return [...targets, ...contexts, ...educations];
});

const tagChips = computed(() => {
  const keywords = (contentDetail.value.itemKeywordList || []).map(
    formatKeyword,
  );
  return [...new Set([...(contentDetail.value.tagList || []), ...keywords])];
});

const selectedLicenseInfo = computed(() =>
  contentDetail.value.contentImage?.imageLicenseList?.find(
    (license) => license.contentImageLicenseId === selectedLicense.value,
  ),
);

const sheetTotalPrice = computed(() => {
  const item = contentDetail.value;
  if (item.itemType === "PRODUCT") {
    if (noneOptionItem.value) return noneOptionItemTotalPrice.value;
    return selectedOptionList.value.reduce(
      (acc, cur) => acc + cur.totalPrice,
      0,
    );
  }
  if (item.contentType === "IMAGE") {
    return selectedLicenseInfo.value?.licensePrice ?? item.sellingPrice ?? 0;
  }
  return item.sellingPrice ?? 0;
});

// 리뷰 사진 모달 관련 함수들
/**
 * 리뷰 사진들을 수집하는 함수
 * @return {Array} 모든 리뷰 사진들의 배열
 */
const getAllReviewPhotos = () => {
  const photos = [];

  if (reviewList.value.reviewList) {
    reviewList.value.reviewList.forEach((review) => {
      if (review.photoList && review.photoList.length > 0) {
        review.photoList.forEach((photo) => {
          photos.push(photo);
        });
      }
    });
  }

  return photos;
};

/**
 * 사진 클릭 시 모달 열기
 * @param {number} photoIndex - 선택된 사진의 인덱스
 */
const openPhotoModal = (photoIndex = 0) => {
  reviewPhotos.value = getAllReviewPhotos();
  selectedPhotoIndex.value = photoIndex;
  isPhotoModalVisible.value = true;
};

/**
 * 더보기 버튼 클릭 시 모든 사진 보기
 */
const viewAllPhotos = () => {
  openPhotoModal(0);
};

/**
 * 모달 닫기
 */
const closePhotoModal = () => {
  isPhotoModalVisible.value = false;
};

/**
 * 모달에서 사진 변경 시 호출
 * @param {number} newIndex - 새로운 사진 인덱스
 */
const handlePhotoChange = (newIndex) => {
  selectedPhotoIndex.value = newIndex;
};

const combinationSelectOption = async (option, idx, require) => {
  console.group(
    ` combinationSelectOption ------------------------------------------- `,
  );

  console.log(option);
  const selectOption =
    require === "R" ? requiredOptionSetting.value : optionSetting.value;
  console.log(selectOption);

  console.log(selectedOption.value);
  console.log(selectedOption.value[idx]);

  const optionCombined = contentDetail.value.optionCombined;
  selectedOption.value[idx].optionCombined = optionCombined;

  // 조합형
  if (optionCombined === true) {
    const optionCount = selectOption.length - 1;
    console.log(optionCount, idx);
    if (optionCount <= idx) {
      addOption(
        selectedOption.value[idx],
        option.optionId,
        require,
        optionCombined,
      );
    } else {
      getOptionList(idx);
    }
  }
  // 비조합형
  else {
    selectedOption.value[`combinationId${idx + 1}`] =
      selectedOption.value.combinationId;
    selectedOption.value.combinationId = null;

    // selectedOption.value[idx][`combinationId${idx + 1}`] = option.combinationId;
    console.log(selectedOption.value[`combinationId${idx + 1}`]);
    console.log(selectedOption.value);

    const optionCount = selectOption.length - 1;
    console.log(optionCount, idx);

    console.groupEnd();
    if (optionCount <= idx) {
      addOption(selectedOption.value, option.optionId, require, optionCombined);
    }
    // addOption(selectedOption.value[idx], option.optionId, require, optionCombined);
  }

  // 일반 옵션 예시
  const normalOptionSetting = ref([
    {
      idx: 4,
      type: "default",
      title: "선택옵션1",
      values: ["선택옵션1-1", "선택옵션1-2"],
      isRequire: false,
      price: 0,
    },
    {
      idx: 5,
      type: "default",
      title: "선택옵션2",
      values: ["선택옵션2-1", "선택옵션2-2", "선택옵션2-3"],
      isRequire: false,
      price: 1000,
    },
  ]);
};
// 예시
const getOptionList = (idx) => {
  console.log("getOptionList");
  console.log(selectedOption.value[idx]);
  let elements = "";
  selectedOption.value.forEach((val, index) => {
    if (val !== "" && val !== undefined && val !== null) {
      elements += (index === 0 ? "?" : "&") + `elements=${val.elementName}`;
    }
  });
  console.log(elements);

  // const url = `/api/product/${itemId}/options?elements=A&elements=1`;
  const url = `/new_api/product/${itemId}/options${elements}`;
  axios
    .get(url)
    .then((res) => {
      console.log(res.data.data.paths);
      requiredOptionSetting.value[idx + 1].optionNodeList = res.data.data.paths;
      selectedOptionTitle.value =
        selectedOptionTitle.value !== null
          ? selectedOptionTitle.value +
            " > " +
            selectedOption.value[idx].elementName
          : selectedOption.value[idx].elementName;
      // selectedOptionTitle.value + ' > ' + selectedOption.value[idx].elementName;
    })
    .catch((error) => {
      console.error(error);
    });
};

const normalSelectOption = (option, idx, require) => {
  console.group(
    ` normalSelectOption ------------------------------------------- `,
  );
  console.log(option);
  // const selectedOption = event.target.value;
  const selectedOption = normalOption.value[idx];
  if (selectedOption !== "") {
    const item = {
      optionIdx: selectedOption.optionId,
      race: "normal",
      type: option.type,
      title: selectedOption.elementName,
      option: selectedOption.combinationId,
      count: 1,
      price: selectedOption.price,
      totalPrice: selectedOption.price * 1,
      value: null,
    };

    console.log(item);
    // selectedOptionList 중복 확인
    let overlap = false;

    if (item.type === "input") {
      selectedOptionList.value.forEach((val, index) => {
        if (val.optionIdx === item.optionIdx) {
          alert(" .");
          overlap = true;
          return false;
        }
      });
    } else {
      selectedOptionList.value.forEach((val, index) => {
        if (JSON.stringify(val.option) === JSON.stringify(item.option)) {
          alert("이미 선택된 옵션입니다.");
          overlap = true;
          return false;
        }
      });
    }

    if (overlap === false) {
      selectedOptionList.value.push(item);
    }

    normalOption.value[idx] = ""; // 초기화
  }

  console.groupEnd();
};

/**
 * 옵션 추가
 * @param option
 * @param optionId
 * @param require - 필수항목
 * @param optionCombined - 조합, 비조합 판단
 */
const addOption = (option, optionId, require = null, optionCombined) => {
  console.group(` addOption ------------------------------------------- `);
  console.log(`++++++++++++++++++++++++++++++++++++++++`);
  console.log(optionCombined);
  console.log(option);
  console.log(`++++++++++++++++++++++++++++++++++++++++`);
  let item;
  if (optionCombined === false) {
    const title = option.map((val) => val.elementName).join(" > ");
    const price = option.reduce((acc, cur) => acc + cur.price, 0);
    // optionIdx: optionId,
    item = {
      optionIdx: null,
      race: optionCombined === "Y" ? "combination" : "noneCombination",
      type: option.type,
      title: title,
      option: option.combinationId,
      count: 1,
      price: price,
      totalPrice: price * 1,
      value: option.value,
      optionMessage: option.optionMessage ? option.optionMessage : null,
      require: require,
      combinationId1: option[0].combinationId,
      combinationId2: option[1].combinationId,
      combinationId3: option[2].combinationId,
    };

    console.log(`item +++++++++++++++++++++++++++++++++++++++++++++ `);
    console.log(item);
    console.log(`item +++++++++++++++++++++++++++++++++++++++++++++ `);
  } else {
    item = {
      optionIdx: optionId,
      race: optionCombined === "Y" ? "combination" : "noneCombination",
      type: option.type,
      title: option.title ? option.title : null,
      option: option.combinationId,
      count: 1,
      price: option.price,
      totalPrice: option.price * 1,
      value: option.value,
      optionMessage: option.optionMessage ? option.optionMessage : null,
      require: require,
      combinationId1: option.combinationId1,
      combinationId2: option.combinationId2,
      combinationId3: option.combinationId3,
    };
    if (option.value) {
      item.value = option.value;
    }
  }

  console.log(item);

  // selectedOptionList 중복 확인
  let overlap = false;
  selectedOptionList.value.forEach((val, index) => {
    if (
      JSON.stringify(val.option) === JSON.stringify(item.option) &&
      JSON.stringify(val.combinationId1) ===
        JSON.stringify(item.combinationId1) &&
      JSON.stringify(val.combinationId2) ===
        JSON.stringify(item.combinationId2) &&
      JSON.stringify(val.combinationId3) === JSON.stringify(item.combinationId3)
    ) {
      alert("이미 선택된 옵션입니다..");
      overlap = true;
      return false;
    }
  });

  if (overlap === false) {
    /*console.log(item);
    console.log(item.title);
    console.log(`selectedOptionTitle.value : ${selectedOptionTitle.value}`);*/
    if (item.title === null) {
      if (selectedOptionTitle.value !== null) {
        item.title = selectedOptionTitle.value + " > " + option.elementName;
      } else {
        item.title = option.elementName;
      }
    }
    selectedOptionList.value.push(item);
    selectedOptionTitle.value = null; // 상품명 초기화
  }
  selectedOption.value = new Array(combinationOptionSetting.value.length).fill(
    "",
  );

  console.groupEnd();
};

const makeWriteOption = (option) => {
  console.log(option.inputData);
  // console.log(option.optionType);

  const writeOption = {
    type: option.optionType,
    title: option.inputData,
    combinationId: option.optionNodeList[0].combinationId,
    price: option.optionNodeList[0].price,
    value: null,
    optionMessage: option.inputData,
  };
  option.inputData = ""; // 초기화
  addOption(writeOption, option.optionId);
};

const optionDecreaseQuantity = (item, index) => {
  // selectedOptionList.value[index].count--;
  const option = selectedOptionList.value[index];
  if (option.count > 1) {
    option.count--;
    option.totalPrice = option.price * option.count;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

const optionIncreaseQuantity = (item, index) => {
  const option = selectedOptionList.value[index];
  option.count++;
  option.totalPrice = option.price * option.count;
};

const optionDecreaseQuantityNone = () => {
  // selectedOptionList.value[index].count--;

  if (noneOptionItemInfo.value.productStock > 1) {
    noneOptionItemInfo.value.productStock--;
    noneOptionItemTotalPrice.value =
      noneOptionItemPrice.value * noneOptionItemInfo.value.productStock;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

const optionIncreaseQuantityNone = () => {
  noneOptionItemInfo.value.productStock++;
  noneOptionItemTotalPrice.value =
    noneOptionItemPrice.value * noneOptionItemInfo.value.productStock;
};

/* ************************************************************************************************************** */

const requiredOptionSetting = ref([]); // 필수 옵션 목록
// const requiredWriteSetting = ref([]);    // 옵션 목록
const writeSetting = ref([]); // 옵션 목록
const optionSetting = ref([]); // 옵션 목록

/* ************************************************************************************************************** */

// 상품 상세 GET
const getItemInfo = async () => {
  try {
    const url = `/new_api/customer/item/${itemId}`;
    const { data, status } = await axios.get(url);
    const item = data.data;
    console.log(item);
    item.itemType = item.code.startsWith("P") ? "PRODUCT" : "CONTENT";
    item.itemId = item.code.startsWith("P") ? item.productId : item.contentId;
    item.relationItemList = (item.relationItemList || []).slice(0, 8);
    contentDetail.value = item;
    if (item.itemType === "PRODUCT") {
      // TODO: 두번째 부터 옵션 리스트들 초기화
      item.optionList.forEach((option, index) => {
        if (index > 0 && option.depth === 1) {
          option.optionNodeList = [];
        }
      });

      // console.log(item.optionList);

      // 필수 옵션
      requiredOptionSetting.value = item.optionList.filter(
        (option) => option.required === true && option.optionType === "TREE",
      );
      /*requiredOptionSetting.value.map((option, index) => {
        option.required = true;
      });*/
      // 선택 옵션
      normalOptionSetting.value = item.optionList.filter(
        (option) => option.required === false && option.optionType === "TREE",
      );
      // 입력 옵션
      writeSetting.value = item.optionList.filter(
        (option) => option.optionType === "WRITING",
      );

      noneOptionItem.value =
        requiredOptionSetting.value.length === 0 &&
        normalOptionSetting.value.length === 0 &&
        writeSetting.value.length === 0;
      if (noneOptionItem.value === true) {
        noneOptionItemInfo.value.itemId = item.itemId;
        noneOptionItemPrice.value = item.sellingPrice;
        noneOptionItemTotalPrice.value = item.sellingPrice;
      }

      // 출고지 정보
      warehouseInfo.value = item.warehouse;
    }

    if (contentDetail.value.contentImage !== undefined) {
      if (contentDetail.value.contentImage.imageLicenseList.length > 0) {
        selectedLicense.value =
          contentDetail.value.contentImage.imageLicenseList[0].contentImageLicenseId;
      }
    }
  } catch (err) {
    console.error(err);
  }
};

// 상품 리뷰 목록 GET
const getReviewList = async () => {
  try {
    const res = await axios.get(
      "/new_api/review/list?page=1&size=10&itemId=" + itemId,
    );
    reviewList.value = res.data.data;

    // TODO: 개발용 더미 데이터 추가 (실제 배포시 제거 필요)
    addDummyPhotosToReviews();
  } catch (err) {
    console.error(err);
    // API 호출 실패시에도 더미 데이터로 테스트 가능하도록
    createDummyReviewData();
  }
};

/**
 * 개발/테스트용 더미 사진 데이터 추가 함수
 * 실제 배포시에는 제거해야 함
 */
const addDummyPhotosToReviews = () => {
  if (!reviewList.value.reviewList) {
    reviewList.value.reviewList = [];
  }

  // 더미 사진 URL 배열 (무료 이미지 서비스 이용)
  const dummyPhotos = [
    "https://picsum.photos/400/400?random=1",
    "https://picsum.photos/400/400?random=2",
    "https://picsum.photos/400/400?random=3",
    "https://picsum.photos/400/400?random=4",
    "https://picsum.photos/400/400?random=5",
    "https://picsum.photos/400/400?random=6",
    "https://picsum.photos/400/400?random=7",
    "https://picsum.photos/400/400?random=8",
    "https://picsum.photos/400/400?random=9",
    "https://picsum.photos/400/400?random=10",
    "https://picsum.photos/400/400?random=11",
    "https://picsum.photos/400/400?random=12",
  ];

  // 기존 리뷰가 있다면 더미 사진 추가
  if (reviewList.value.reviewList.length > 0) {
    reviewList.value.reviewList.forEach((review, index) => {
      if (!review.photoList) {
        review.photoList = [];
      }

      // 각 리뷰에 1-3개의 랜덤 사진 추가
      const photoCount = Math.floor(Math.random() * 3) + 1;
      const startIndex = (index * 3) % dummyPhotos.length;

      for (let i = 0; i < photoCount; i++) {
        const photoIndex = (startIndex + i) % dummyPhotos.length;
        review.photoList.push(dummyPhotos[photoIndex]);
      }
    });
  }
};

// 상품 리뷰 상세 GET
const getReviewDetail = async (id) => {
  try {
    const res = await axios.get("/new_api/review/" + id);
    console.log(res);
    reviewDetail.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

// 상세이미지 사이즈에 따른 버튼 출력
const checkImageHeight = () => {
  const detailImage = document.querySelector('[data-ref="detailImage"]');
  if (detailImage) {
    const imageHeight = detailImage.clientHeight;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    if (imageHeight > viewportHeight * 0.5) {
      isImageFolded.value = true;
      togglerActive.value = true;
    }
  }
};

const toggleImage = () => {
  isImageFolded.value = !isImageFolded.value;
};

// 상품 수량 증감
const increaseQuantity = () => {
  quantity.value++;
};

const decreaseQuantity = () => {
  if (quantity.value > 1) {
    quantity.value--;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

// 장바구니 추가
const addCart = async () => {
  const token = localStorage.getItem("authorization");
  if (!token) {
    openLoginDialog();
    return;
  }
  console.log(` addCart START ------------------------------- `);

  console.log(contentDetail.value.itemId, contentDetail.value.itemType);

  /**
   * 1. 콘텐츠 이미지 제외 장바구니 담기
   * 2. 콘텐츠 이미지 장바구니 담기
   * 3. 상품 옵션 장바구니 담기
   */
  // isSelected : true, // 장바구니 담기시 체크 되는 부분
  let param = {
    itemId: null,
    quantity: null,
    licenseId: null,
    productStock: null,
    productOptionList: null,
  };
  param.itemId = contentDetail.value.itemId;
  // 콘텐츠 데이터 추가
  if (contentDetail.value.itemType === "CONTENT") {
    // 이미지 - 라이센스 선택 추가
    param.quantity = 1;
    if (contentDetail.value.contentType === "IMAGE") {
      param.licenseId = selectedLicense.value;
      param.quantity = quantity.value;
    }
  }
  // 상품 데이터 추가
  else {
    if (noneOptionItem.value === true) {
      param.productStock = noneOptionItemInfo.value.productStock;
    } else {
      param.productStock = "";
      // param.productOptionList = "";
      console.log(selectedOptionList.value);
      let productOptionList = [];
      selectedOptionList.value.forEach((item, index) => {
        productOptionList.push({
          require: item.require === "R",
          optionId: item.optionIdx,
          combinationId: item.option,
          quantity: item.count,
          optionMessage: item.optionMessage, // 입력형 옵션
          // 비조합형 필수 옵션 조합 아이디
          combinationId1: item.combinationId1,
          combinationId2: item.combinationId2,
          combinationId3: item.combinationId3,
        });
      });

      // 필수 항목 체크
      // require 1개 이상 체크
      let requireCheck = false;
      requiredOptionSetting.value.forEach((item, index) => {
        if (
          productOptionList.filter((option) => option.require === true).length >
          0
        ) {
          requireCheck = true;
        }
      });

      if (requireCheck === false) {
        alert("필수 옵션을 하나 이상 선택해 주세요.");
        return false;
      }

      console.log(productOptionList);
      if (productOptionList.length > 0) {
        param.productOptionList = productOptionList;
      } else {
        alert("옵션을 선택해 주세요.");
        return false;
      }
    }
  }

  console.log(param);
  console.log(` addCart END ------------------------------- `);
  // return false;

  // 유효성 검사

  try {
    await axios.post("/new_api/customer/cart/v2/edit", param).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        if (res.data.code === "200") {
          alert("장바구니에 담겼습니다.");
          router.push({ name: "cart" }); // 장바구니 이동 여부 묻도록 변경할 것
        } else if (res.data.code === "031") {
          if (
            res.data.reasons.includes(
              "IllegalData.OrderContent.STILL_AVAILABLE",
            )
          ) {
            alert("이미 구매하신 콘텐츠입니다. 콘텐츠함을 확인하세요.");
            return false;
          }
          // 재고 부족
          console.log(res.data.pathNameList);
          const pathNameList = res.data.pathNameList.join(", ");
          console.log(pathNameList);
          const alert_msg = `재고가 부족한 옵션이 포함 되어 있습니다.\n\n${res.data.optionName} - ${pathNameList}`;
          alert(alert_msg);
          return false;
        } else if (res.data.code === "032") {
          // TODO: 상품 불러올 때 판매중지 여부 체크 필요
          alert("판매중지된 상품이므로 구매하실 수 없습니다.");
          window.location.reload();
        }
      } else {
        console.log(res);
      }
    });
  } catch (e) {
    console.log(e);
  }

  /*
  editCart(
    contentDetail.value.itemId,
    quantity.value,
    true,
    'CREATE',
    selectedLicense.value
  ).then((res) => {
    console.log(res)
    if (res.data.code === '200') {
      alert('장바구니에 담겼습니다.');
      router.push({ name: 'cart' }); // 장바구니 이동 여부 묻도록 변경할 것
    } else if (res.data.code === '032') {
      alert('판매중지된 상품이므로 구매하실 수 없습니다.');
      window.location.reload();
    }
  });
   */
};

const deleteCart = (item) => {
  selectedOptionList.value = selectedOptionList.value.filter(
    (option) => option !== item,
  );
};

const refreshPage = (related) => {
  window.location.href = "/mall/view/" + related;
};

// 팝오버 관련 메소드들
const showPopover = (type) => {
  clearTimeout(popoverTimer.value);
  activePopover.value = type;
};

const hidePopover = (type) => {
  popoverTimer.value = setTimeout(() => {
    if (activePopover.value === type) {
      activePopover.value = null;
    }
  }, 300);
};

const togglePopover = (type) => {
  if (activePopover.value === type) {
    activePopover.value = null;
  } else {
    activePopover.value = type;
  }
};

const getGroupedTargets = (list) => {
  if (!list || list.length === 0) return [];

  const groupedMap = list.reduce((acc, item) => {
    if (!acc[item.groupType]) {
      acc[item.groupType] = [];
    }
    acc[item.groupType].push(item.groupNameValue);
    return acc;
  }, {});

  return Object.keys(groupedMap).map((type) => {
    const names = groupedMap[type].join(", "); // 예: "유년부, 초등부"
    let suffix = "";

    if (type === "AGE_GROUP") {
      suffix = " 활동에 좋아요";
    } else if (type === "ROLES") {
      suffix = "님께 추천해요";
    }

    return { names, suffix };
  });
};

const formatKeyword = (item) => {
  if (item.depth1 === item.depth2) {
    return item.depth1;
  }
  return `${item.depth1} ${item.depth2}`;
};

// 구매 버튼: 고를 옵션이 없으면 바로 담고, 있으면 옵션 시트를 연다
const openPurchase = () => {
  if (isSoldOut.value) return;
  if (!needsPurchaseSheet.value) {
    addCart();
    return;
  }
  if (!localStorage.getItem("authorization")) {
    openLoginDialog();
    return;
  }
  isPurchaseSheetOpen.value = true;
};

const closePurchaseSheet = () => {
  isPurchaseSheetOpen.value = false;
};

const handleKeydown = (event) => {
  if (event.key === "Escape" && isPurchaseSheetOpen.value) {
    closePurchaseSheet();
  }
};

watch(isPurchaseSheetOpen, (isOpen) => {
  document.body.style.overflow = isOpen ? "hidden" : "";
  if (isOpen) nextTick(() => sheetCloseRef.value?.focus());
});

const shareLink = async () => {
  const url = window.location.href;
  try {
    if (navigator.share && window.matchMedia("(max-width: 767px)").matches) {
      await navigator.share({ title: contentDetail.value.title, url });
      return;
    }
    await navigator.clipboard.writeText(url);
    alert("링크가 복사되었습니다.");
  } catch (err) {
    if (err?.name !== "AbortError") console.error(err);
  }
};

// 헤더 높이(--sticky-top) + 이동 탭 높이 = 섹션이 가려지지 않는 상단 여백
const getTabOffset = () => {
  const rootStyle = getComputedStyle(document.documentElement);
  const stickyTopValue = rootStyle.getPropertyValue("--sticky-top").trim();
  const stickyTop =
    parseFloat(stickyTopValue || rootStyle.getPropertyValue("--nav-height")) ||
    0;
  return stickyTop + (tabBarRef.value?.offsetHeight || 0);
};

// 현재 보고 있는 섹션의 탭을 활성화 (섹션 상단이 탭 바로 아래를 지나면 전환)
const updateActiveTab = () => {
  const ids = visibleMenuList.value.map((menu) => menu.id);
  const scrollBottom = window.innerHeight + window.scrollY;
  // 페이지 끝에 닿으면 짧은 마지막 섹션도 활성화되도록 처리
  if (scrollBottom >= document.documentElement.scrollHeight - 2) {
    activeId.value = ids[ids.length - 1];
    return;
  }
  const threshold = getTabOffset() + 80;
  let current = ids[0];
  ids.forEach((id) => {
    const element = document.getElementById(id);
    if (element && element.getBoundingClientRect().top <= threshold) {
      current = id;
    }
  });
  activeId.value = current;
};

let spyFrame = null;
const handleScroll = () => {
  if (spyFrame) return;
  spyFrame = requestAnimationFrame(() => {
    spyFrame = null;
    updateActiveTab();
  });
};

// Nav.vue의 MOBILE_BREAKPOINT와 같은 값 (이보다 좁으면 Nav가 숨지 않는다)
const NAV_MOBILE_BREAKPOINT = 1024;

// 탭 이동: 섹션 제목이 탭 바로 아래에 오도록 스크롤
// 데스크톱 Nav는 아래로 스크롤하면 숨고 위로 스크롤하면 나타나므로, 이동 후의 Nav 상태를 예측해 목표 위치를 정한다
const scrollToTarget = (id) => {
  const element = document.getElementById(id);
  if (!element) return;
  activeId.value = id;
  const anchor = element.querySelector(".detail_section_head") || element;
  const navHeight =
    parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--nav-height",
      ),
    ) || 0;
  const tabHeight = tabBarRef.value?.offsetHeight || 0;
  const anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  const clamp = (value) => Math.max(0, Math.min(value, maxScroll));

  const topWithoutNav = clamp(anchorTop - tabHeight - 24);
  const navWillHide =
    window.innerWidth >= NAV_MOBILE_BREAKPOINT &&
    topWithoutNav > window.scrollY &&
    topWithoutNav > navHeight;
  const top = navWillHide
    ? topWithoutNav
    : clamp(anchorTop - navHeight - tabHeight - 24);
  if (Math.abs(top - window.scrollY) < 2) return;

  window.scrollTo({ top, behavior: "smooth" });
};

let ctaObserver = null;

onMounted(async () => {
  await Promise.all([getItemInfo(), getReviewList()]);

  checkImageHeight();
  window.addEventListener("resize", checkImageHeight);

  selectedOption.value = new Array(requiredOptionSetting.value.length).fill("");
  normalOption.value = new Array(normalOptionSetting.value.length).fill("");

  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("keydown", handleKeydown);
  await nextTick();
  updateActiveTab();

  // 대표 영역 구매 버튼이 상단으로 사라지면 플로팅 구매바를 노출
  ctaObserver = new IntersectionObserver(
    ([entry]) => {
      isFloatingVisible.value =
        !entry.isIntersecting && entry.boundingClientRect.top < 0;
    },
    { rootMargin: "-80px 0px 0px 0px" },
  );
  if (heroCtaRef.value) ctaObserver.observe(heroCtaRef.value);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkImageHeight);
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("keydown", handleKeydown);
  if (spyFrame) cancelAnimationFrame(spyFrame);
  if (ctaObserver) ctaObserver.disconnect();
  document.body.style.overflow = "";
});
</script>

<style scoped>
body {
  overflow-x: hidden;
}

.selectClass {
  @apply w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-[0.9375rem] outline-none transition-colors focus:border-[#0c3388];
}
.countBox {
  @apply py-2 px-3 inline-block bg-white rounded-lg dark:bg-slate-900 dark:border-gray-700;
}

/* 팝오버 스타일 */
.popover-item {
  @apply w-full bg-blue-50 px-2 py-1 rounded-full cursor-pointer whitespace-pre relative;
}

.popover-content {
  @apply absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-slate-800 text-white text-sm rounded-lg z-10 whitespace-nowrap;
}

.popover-arrow {
  @apply absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-slate-800;
}

/* 상세 페이지 공통 색상 (Teleport로 body에 붙는 요소에도 적용) */
.detail_page,
.detail_float,
.detail_sheet_backdrop {
  --detail-navy: var(--main-navy, #0c3388);
  --detail-navy-dark: #0a2a70;
  --detail-ink: #1b1d21;
  --detail-body: #3a3d44;
  --detail-muted: #898c92;
  --detail-line: #e5e7eb;
  --detail-soft: #f4f6fb;
  --detail-accent: #ffd84d;
  --detail-sale: #ff4a4a;
}

/* 대표 영역 */
.detail_hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  padding: 1.25rem 0 3.5rem;
}

.detail_hero_thumb {
  width: 100%;
  max-width: 35.75rem;
  aspect-ratio: 3 / 2;
  border: 1px solid var(--detail-line);
  border-radius: 0.75rem;
  background: var(--detail-soft);
  overflow: hidden;
}

.detail_hero_thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail_hero_thumb img.detail_hero_thumb_empty {
  object-fit: contain;
  padding: 18%;
}

.detail_hero_info {
  width: 100%;
  max-width: 31.25rem;
  margin-top: 2rem;
  text-align: center;
}

.detail_hero_category {
  color: var(--detail-muted);
  font-size: 0.9375rem;
}

.detail_hero_title {
  margin-top: 0.375rem;
  color: var(--detail-ink);
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.02em;
  word-break: keep-all;
}

.detail_hero_meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
  color: var(--detail-muted);
  font-size: 0.875rem;
}

.detail_hero_meta button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  transition: color 0.2s;
}

.detail_hero_meta button:hover {
  color: var(--detail-ink);
}

.detail_hero_meta b {
  color: var(--detail-ink);
  font-weight: 600;
}

.detail_hero_brand {
  padding-left: 0.75rem;
  border-left: 1px solid var(--detail-line);
}

.detail_hero_buy {
  width: 100%;
  max-width: 22.5rem;
  margin-top: 2rem;
}

/* 구매 버튼 (대표 영역 · 플로팅 바 · 옵션 시트 공용) */
.detail_cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  width: 100%;
  min-height: 3.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  background: var(--detail-navy);
  color: #fff;
  transition: background-color 0.2s, transform 0.1s;
}

.detail_cta:hover {
  background: var(--detail-navy-dark);
}

.detail_cta:active {
  transform: scale(0.99);
}

.detail_cta:disabled {
  background: #c8cbd0;
  cursor: not-allowed;
  transform: none;
}

.detail_cta b {
  font-size: 1rem;
  font-weight: 600;
}

.detail_cta em {
  color: var(--detail-accent);
  font-style: normal;
}

.detail_cta_hint {
  font-size: 0.6875rem;
  opacity: 0.75;
}

.detail_hero_sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  color: var(--detail-muted);
  font-size: 0.8125rem;
}

.detail_hero_sub button {
  flex-shrink: 0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.detail_hero_sub button:hover {
  color: var(--detail-ink);
}

/* 이동 탭: 알약형 탭, Nav 숨김/노출(700ms)과 같은 속도로 위치 이동 */
.detail_tabbar {
  position: sticky;
  /* Nav가 아직 --sticky-top을 정하지 않았다면 Nav는 노출 상태이므로 Nav 높이 사용 */
  top: var(--sticky-top, var(--nav-height, 0px));
  z-index: 10;
  padding: 0.75rem 0;
  transition: top 0.7s ease-in-out;
}

/* 배경·하단선만 화면 전체 폭으로 확장 (탭 버튼은 본문 폭 기준으로 정렬) */
/* .detail_tabbar::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(50% - 50vw);
  right: calc(50% - 50vw);
  z-index: -1;
  border-bottom: 1px solid var(--detail-line);
  background: #fff;
} */

.detail_tabbar_list {
  display: flex;
  gap: 0.25rem;
  max-width: 65rem;
  margin: 0 auto;
  padding: 0.25rem;
  border-radius: 9999px;
  background: #f1f3f7;
}

.detail_tabbar_list li {
  flex: 1;
}

.detail_tabbar_list button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  width: 100%;
  padding: 0.625rem 0.5rem;
  border-radius: 9999px;
  color: var(--detail-muted);
  font-size: 1rem;
  white-space: nowrap;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
}

.detail_tabbar_list button:hover {
  color: var(--detail-ink);
}

.detail_tabbar_list li.active button {
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);
  color: var(--detail-navy);
  font-weight: 700;
}

.detail_tabbar_count {
  min-width: 1.25rem;
  padding: 0 0.375rem;
  border-radius: 9999px;
  background: #e3e8f4;
  color: var(--detail-navy);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25rem;
}

/* 본문 컬럼 */
.detail_column {
  max-width: 54.5rem;
  margin: 0 auto;
}

/* 섹션 사이는 얇은 구분선, 제목 옆에 개수 칩 */
.detail_section {
  margin: 0;
  padding: 2rem 0;
}

.detail_section#intro {
  padding-top: 0;
}

.detail_section + .detail_section {
  border-top: 1px solid var(--detail-line);
}

.detail_section_head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.detail_section_head h2 {
  color: var(--detail-ink);
  font-size: 1.5rem;
  font-weight: 700;
}

.detail_section_count {
  min-width: 1.5rem;
  padding: 0 0.5rem;
  border-radius: 9999px;
  background: #eef2fb;
  color: var(--detail-navy);
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;
}

.detail_share {
  padding: 0.25rem;
  color: var(--detail-ink);
  transition: opacity 0.2s;
}

.detail_share:hover {
  opacity: 0.6;
}

/* 핵심 정보 요약 */
.detail_summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 2rem;
  margin: 2rem 0 2.5rem;
  padding: 1.75rem 2rem;
  border-radius: 0.875rem;
  background: var(--detail-soft);
}

.detail_summary_item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 1;
}

.detail_summary_item dt {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.375rem;
  width: 7.5rem;
  color: var(--detail-muted);
  white-space: nowrap;
}

.detail_summary_item dd {
  color: var(--detail-navy);
  font-weight: 700;
  word-break: keep-all;
}

/* 활용 포인트 */
.detail_points {
  margin-bottom: 2.5rem;
}

.detail_points_title {
  margin-bottom: 0.875rem;
  color: var(--detail-ink);
  font-size: 1.0625rem;
  font-weight: 700;
}

.detail_points ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  gap: 0.75rem;
}

.detail_points li {
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  padding: 1rem 1.125rem;
  border: 1px solid var(--detail-line);
  border-radius: 0.875rem;
}

.detail_points_icon {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  background: #eef2fb;
  color: var(--detail-navy);
}

.detail_points_kind {
  color: var(--detail-muted);
  font-size: 0.75rem;
  font-weight: 600;
}

.detail_points_text {
  margin-top: 0.125rem;
  color: var(--detail-body);
  font-size: 0.9375rem;
  line-height: 1.45;
  word-break: keep-all;
}

.detail_points_text b {
  color: var(--detail-ink);
  font-weight: 700;
}

/* 태그 */
.detail_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2.5rem;
}

.detail_tags li {
  padding: 0.375rem 0.75rem;
  border: 1px solid var(--detail-line);
  border-radius: 9999px;
  color: #555961;
  font-size: 0.8125rem;
}

.detail_sample {
  margin-bottom: 2rem;
}

.detail_column .mall_detail_img {
  max-width: none;
  padding: 0;
}

/* 이용안내 */
.detail_guide {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  color: var(--detail-body);
  font-size: 0.9375rem;
  line-height: 1.75;
}

.detail_guide h3 {
  margin-bottom: 0.375rem;
  padding: 0;
  color: var(--detail-ink);
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
}

.detail_guide li {
  position: relative;
  padding-left: 0.875rem;
}

.detail_guide li::before {
  content: "";
  position: absolute;
  top: 0.8em;
  left: 0;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 9999px;
  background: var(--detail-muted);
}

/* 리뷰 */
.detail_review_list {
  padding-top: 0.5rem;
}

.detail_review_list li {
  padding: 1.25rem 0.25rem;
}

.detail_review_list li:not(:last-of-type) {
  border-bottom: 1px solid var(--detail-line);
}

.detail_review_empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 3.5rem 0 1rem;
  color: var(--detail-muted);
}

/* 연관 콘텐츠: 한 줄에 4개 (모바일 2개) */
.detail_column .detail_related {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 2rem 1rem;
  padding: 0;
}

@media (max-width: 767px) {
  .detail_column .detail_related {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem 0.75rem;
  }
}

/* 하단 플로팅 구매바 */
.detail_float {
  position: fixed;
  left: 50%;
  bottom: 0.5rem;
  z-index: 15;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: min(54.5rem, calc(100vw - 2rem));
  padding: 0.5rem 0.5rem 0.5rem 1.25rem;
  border-radius: 0.5rem;
  background: rgba(27, 29, 33, 0.78);
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  color: #fff;
  transform: translateX(-50%);
  backdrop-filter: blur(8px);
}

.detail_float_info {
  min-width: 0;
}

.detail_float_title {
  overflow: hidden;
  font-size: 0.8125rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  opacity: 0.75;
}

.detail_float_price {
  font-size: 1rem;
  font-weight: 700;
}

.detail_float_price strong {
  margin-right: 0.375rem;
  color: var(--detail-sale);
}

.detail_cta--float {
  flex-shrink: 0;
  width: auto;
  min-width: 11.25rem;
  min-height: 3rem;
}

.detail-float-enter-active,
.detail-float-leave-active {
  transition: opacity 0.25s ease, translate 0.25s ease;
}

.detail-float-enter-from,
.detail-float-leave-to {
  opacity: 0;
  translate: 0 1rem;
}

/* 옵션 선택 시트 */
.detail_sheet_backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.45);
}

.detail_sheet {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
  max-height: min(85vh, 45rem);
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.detail_sheet_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.125rem 1.25rem;
  border-bottom: 1px solid var(--detail-line);
}

.detail_sheet_head h2 {
  color: var(--detail-ink);
  font-size: 1.125rem;
  font-weight: 700;
}

.detail_sheet_body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  overflow-y: auto;
}

.detail_sheet_item {
  color: var(--detail-body);
  font-size: 0.9375rem;
  font-weight: 500;
  word-break: keep-all;
}

.detail_sheet_foot {
  padding: 1rem 1.25rem calc(1rem + env(safe-area-inset-bottom));
  border-top: 1px solid var(--detail-line);
}

.detail_sheet_total {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  color: var(--detail-body);
  font-size: 0.9375rem;
}

.detail_sheet_total b {
  color: var(--detail-ink);
  font-size: 1.375rem;
}

.detail_license {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail_license_item {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.125rem 1rem;
  padding: 0.875rem 1rem;
  border: 1px solid var(--detail-line);
  border-radius: 0.625rem;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.detail_license_item:hover {
  border-color: #c5ccdb;
}

.detail_license_item.checked {
  border-color: var(--detail-navy);
  background: #f3f6fd;
  box-shadow: inset 0 0 0 1px var(--detail-navy);
}

.detail_license_item:has(input:focus-visible) {
  outline: 2px solid var(--detail-navy);
  outline-offset: 2px;
}

.detail_license_name {
  color: var(--detail-ink);
  font-weight: 600;
}

.detail_license_desc {
  grid-column: 1;
  color: var(--detail-muted);
  font-size: 0.8125rem;
}

.detail_license_price {
  grid-row: 1 / span 2;
  grid-column: 2;
  align-self: center;
  color: var(--detail-ink);
}

.detail_delivery {
  display: flex;
  gap: 1.25rem;
  padding: 0.875rem 1rem;
  border-radius: 0.625rem;
  background: var(--detail-soft);
  color: var(--detail-body);
  font-size: 0.875rem;
}

.detail_delivery > span {
  flex-shrink: 0;
  color: var(--detail-muted);
}

.detail_option_label {
  margin-bottom: 0.375rem;
  color: var(--detail-body);
  font-size: 0.875rem;
  font-weight: 500;
}

.detail_selected_list li {
  padding: 0.875rem 1rem;
  border-radius: 0.625rem;
  background: var(--detail-soft);
  font-size: 0.9375rem;
}

.detail_selected_list li + li {
  margin-top: 0.5rem;
}

.detail_selected_list .countBox {
  padding: 0.25rem 0.5rem;
}

.detail-sheet-enter-active,
.detail-sheet-leave-active,
.detail-sheet-enter-active .detail_sheet,
.detail-sheet-leave-active .detail_sheet {
  transition: opacity 0.25s ease, translate 0.25s ease;
}

.detail-sheet-enter-from,
.detail-sheet-leave-to {
  opacity: 0;
}

.detail-sheet-enter-from .detail_sheet,
.detail-sheet-leave-to .detail_sheet {
  translate: 0 1.5rem;
}

/* 태블릿 이하: 본문 좌우 여백 */
@media (max-width: 1023px) {
  .detail_hero_thumb {
    width: calc(100% - 2rem);
  }

  .detail_tabbar {
    padding: 0.625rem 1rem;
  }

  .detail_column {
    padding: 0 1rem;
  }
}

/* 모바일: 썸네일 꽉 차게, 제목 왼쪽 정렬, 플로팅 바 화면 하단에 붙임 */
@media (max-width: 767px) {
  .detail_hero {
    align-items: stretch;
    padding: 0.5rem 0 2.5rem;
  }

  .detail_hero_thumb {
    width: 100%;
    max-width: none;
    border: 0;
    border-radius: 0;
  }

  .detail_hero_info {
    max-width: none;
    margin-top: 1.5rem;
    padding: 0 1rem;
    text-align: left;
  }

  .detail_hero_category {
    font-size: 0.875rem;
  }

  .detail_hero_title {
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .detail_hero_meta {
    justify-content: flex-start;
    margin-top: 0.75rem;
  }

  .detail_hero_buy {
    max-width: none;
    margin-top: 1.75rem;
    padding: 0 1rem;
  }

  .detail_cta {
    min-height: 3rem;
  }

  .detail_tabbar_list button {
    padding: 0.5rem 0.25rem;
    font-size: 0.8125rem;
  }

  .detail_section_head h2 {
    font-size: 1.25rem;
  }

  .detail_summary {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
    margin: 1.5rem 0 2rem;
    padding: 1.25rem;
  }

  .detail_summary_item {
    font-size: 0.9375rem;
  }

  .detail_summary_item dt {
    width: 7.5rem;
  }

  .detail_points ul {
    grid-template-columns: minmax(0, 1fr);
  }

  .detail_float {
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0.5rem 1rem calc(0.5rem + env(safe-area-inset-bottom));
    border-radius: 0;
    transform: none;
  }

  .detail_float_title {
    display: none;
  }

  .detail_cta--float {
    min-width: 9rem;
    min-height: 2.75rem;
  }

  .detail_sheet_backdrop {
    align-items: flex-end;
    padding: 0;
  }

  .detail_sheet {
    max-width: none;
    max-height: 85vh;
    border-radius: 1.25rem 1.25rem 0 0;
  }
}
</style>
